/* Toto Cola - theme.js */
(function () {
  'use strict';

  // ---------- Header scroll state ----------
  const header = document.querySelector('[data-header]');
  if (header) {
    const onScroll = () => {
      if (document.documentElement.classList.contains('design-intro-scroll-locked')) return;
      if (window.scrollY > 24) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ---------- Reveal-on-scroll ----------
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-visible'));
  }

  // ---------- Hero parallax ----------
  const heroBg = document.querySelector('[data-hero-bg]');
  if (heroBg && !document.body.classList.contains('template-index') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let ticking = false;
    const onScrollParallax = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const y = window.scrollY;
          heroBg.style.transform = `translate3d(0, ${y * 0.35}px, 0)`;
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', onScrollParallax, { passive: true });
  }

  // ---------- Generic parallax (data-parallax="0.15") ----------
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const parallaxItems = Array.from(document.querySelectorAll('[data-parallax]')).map((el) => ({
      el,
      speed: parseFloat(el.dataset.parallax) || 0.15
    }));
    if (parallaxItems.length) {
      let pTicking = false;
      const updateParallax = () => {
        const vh = window.innerHeight;
        parallaxItems.forEach(({ el, speed }) => {
          const rect = el.getBoundingClientRect();
          if (rect.bottom < -200 || rect.top > vh + 200) return;
          const center = rect.top + rect.height / 2;
          const dist = center - vh / 2;
          el.style.setProperty('--parallax-y', (-dist * speed).toFixed(1) + 'px');
        });
        pTicking = false;
      };
      window.addEventListener('scroll', () => {
        if (!pTicking) {
          window.requestAnimationFrame(updateParallax);
          pTicking = true;
        }
      }, { passive: true });
      window.addEventListener('resize', updateParallax, { passive: true });
      updateParallax();
    }
  }

  // ---------- Quick buy (add then redirect to cart) ----------
  const resetQuickBuyButton = (btn) => {
    if (!btn) return;
    btn.removeAttribute('disabled');
    if (btn.dataset.originalText) {
      btn.textContent = btn.dataset.originalText;
      delete btn.dataset.originalText;
    }
  };

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('form[data-quick-buy]')) return;
    e.preventDefault();
    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) {
      submitBtn.setAttribute('disabled', '');
      submitBtn.dataset.originalText = submitBtn.textContent;
      submitBtn.textContent = '処理中…';
    }
    const formData = new FormData(form);
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } });
      if (!res.ok) {
        const errPayload = await res.json().catch(() => ({}));
        throw new Error(errPayload.description || 'add to cart failed');
      }
      window.location.href = '/cart';
    } catch (err) {
      console.error(err);
      alert('購入に進めませんでした。再度お試しください。\n' + (err.message || ''));
      resetQuickBuyButton(submitBtn);
    }
  });

  // Restore button state when the user navigates back from the cart via
  // browser back (bfcache or fresh load) so it doesn't stay on "処理中…"
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('form[data-quick-buy] [type="submit"]').forEach(resetQuickBuyButton);
  });

  // ---------- Lite YouTube embed (click thumbnail to play inline) ----------
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-yt-id]');
    if (!trigger) return;
    const id = trigger.dataset.ytId;
    if (!id) return;
    e.preventDefault();
    const wrap = document.createElement('div');
    wrap.className = trigger.className + ' is-playing';
    const iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1';
    iframe.title = trigger.getAttribute('aria-label') || 'YouTube video';
    iframe.loading = 'lazy';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.className = 'media-feature__iframe';
    wrap.appendChild(iframe);
    trigger.replaceWith(wrap);
  });

  // ---------- Cart page: quantity / remove / size / purchase type ----------
  // Each tap updates the page at once and records what the shopper wants for that line. One sync loop then
  // brings the cart to the latest wanted state (skipping taps that were superseded mid-request) and, when
  // nothing is left to send, swaps in the server-rendered table.
  const cartLines = new Map();
  let cartSyncing = false;
  let checkoutAfterSync = null;

  const postCart = async (url, body) => {
    const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
    if (!res.ok) {
      const errPayload = await res.json().catch(() => ({}));
      throw new Error(errPayload.description || 'cart update failed');
    }
    return res.json();
  };

  const cartSectionId = () => {
    const section = document.querySelector('.cart-table')?.closest('.shopify-section');
    return section ? section.id.replace('shopify-section-', '') : undefined;
  };

  // Swap only the table and subtotal, not the whole section, so app widgets (SNSGift) stay mounted.
  const applyCartSection = (cart, sectionId) => {
    const html = cart.sections && cart.sections[sectionId];
    if (!html || cart.item_count === 0) { location.reload(); return; }
    const fresh = new DOMParser().parseFromString(html, 'text/html');
    ['.cart-table', '[data-cart-subtotal]'].forEach((sel) => {
      const next = fresh.querySelector(sel);
      const current = document.querySelector(sel);
      if (next && current) current.replaceWith(next);
    });
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  };

  const formatMoney = (cents) => {
    const format = (document.querySelector('.cart-table')?.dataset.moneyFormat || '¥{{amount_no_decimals}}').replace(/<[^>]*>/g, '');
    const amount = cents / 100;
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => (key.includes('no_decimals')
      ? Math.round(amount).toLocaleString('en-US')
      : amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })));
  };

  const parsePlanPrices = (str) => Object.fromEntries((str || '').split(',').filter(Boolean).map((pair) => pair.split(':')));

  const showSubtotal = () => {
    const subtotal = document.querySelector('[data-cart-subtotal]');
    if (!subtotal) return;
    const rows = [...document.querySelectorAll('.cart-table [data-line-item]')];
    subtotal.textContent = formatMoney(rows.reduce((sum, row) => sum + Number(row.dataset.lineTotal || 0), 0));
  };

  const showLinePrice = (row, unitPrice, oneTimePrice, quantity, onPlan) => {
    row.dataset.lineTotal = unitPrice * quantity;
    const cell = row.querySelector('[data-line-price]');
    const badgeText = row.closest('.cart-table')?.dataset.subBadge;
    if (cell) {
      cell.textContent = '';
      if (onPlan && oneTimePrice > unitPrice) {
        const compare = document.createElement('s');
        compare.className = 'cart-line-compare';
        compare.textContent = formatMoney(oneTimePrice * quantity);
        cell.append(compare);
      }
      cell.append(formatMoney(unitPrice * quantity));
      if (onPlan && badgeText) {
        const badge = document.createElement('span');
        badge.className = 'cart-line-badge';
        badge.textContent = badgeText;
        cell.append(badge);
      }
    }
    showSubtotal();
  };

  const planOf = (item) => (item.selling_plan_allocation ? String(item.selling_plan_allocation.selling_plan.id) : '');

  // key/variant/plan/qty are what Shopify has confirmed; `want` is what the shopper last picked.
  const lineFor = (row) => {
    if (!cartLines.has(row)) {
      const d = row.dataset;
      const qty = Number(d.quantity);
      cartLines.set(row, {
        row,
        key: d.key,
        variant: d.variantId,
        plan: d.sellingPlan || '',
        qty,
        unit: Number(d.lineTotal) / qty,
        props: JSON.parse(d.properties || '{}') || {},
        want: { variant: d.variantId, plan: d.sellingPlan || '', qty }
      });
    }
    return cartLines.get(row);
  };

  const isDirty = (line) => line.want.variant !== line.variant || line.want.plan !== line.plan || line.want.qty !== line.qty;

  const pricesFor = (line, variant) => {
    const source = line.row.querySelector(`[data-cart-variant="${variant}"]`) || line.row;
    return { oneTime: Number(source.dataset.price), plans: parsePlanPrices(source.dataset.planPrices) };
  };

  const showWanted = (line) => {
    const { variant, plan, qty } = line.want;
    const { oneTime, plans } = pricesFor(line, variant);
    const unit = variant === line.variant && plan === line.plan ? line.unit : (plan && Number(plans[plan])) || oneTime;
    showLinePrice(line.row, unit, oneTime, qty, !!plan);
  };

  // Add the new combination first, then drop the old line, so a failure never loses the item.
  const moveLine = async (line, want, render) => {
    const item = { id: Number(want.variant), quantity: want.qty };
    if (want.plan) item.selling_plan = Number(want.plan);
    if (Object.keys(line.props).length) item.properties = line.props;
    const added = await postCart('/cart/add.js', { items: [item] });
    const cart = await postCart('/cart/change.js', { id: line.key, quantity: 0, ...render });
    line.key = added.items[0].key;
    return cart;
  };

  // 単品/定期 in place with one request; re-add the line if Shopify rejects or ignores the plan change.
  const switchPlan = async (line, want, render) => {
    let cart;
    try {
      cart = await postCart('/cart/change.js', { id: line.key, quantity: want.qty, selling_plan: want.plan ? Number(want.plan) : null, ...render });
    } catch (err) {
      if (err instanceof TypeError) throw err; // network failure: cart state unknown
      return moveLine(line, want, render);
    }
    const same = cart.items.find((item) => item.key === line.key);
    if (same && planOf(same) !== want.plan) return moveLine(line, want, render);
    if (!same) {
      const moved = cart.items.find((item) => String(item.variant_id) === line.variant && planOf(item) === want.plan);
      if (!moved) throw new Error('cart line not found');
      line.key = moved.key;
    }
    return cart;
  };

  const syncLine = async (line, render) => {
    const want = { ...line.want };
    let cart;
    if (want.qty === 0) cart = await postCart('/cart/change.js', { id: line.key, quantity: 0, ...render });
    else if (want.variant !== line.variant) cart = await moveLine(line, want, render);
    else if (want.plan !== line.plan) cart = await switchPlan(line, want, render);
    else cart = await postCart('/cart/change.js', { id: line.key, quantity: want.qty, ...render });
    Object.assign(line, want);
    if (want.qty === 0) cartLines.delete(line.row);
    return cart;
  };

  // Shown only when an update takes long enough to notice, so quick ones don't flash.
  let syncStatusTimer = null;
  const setSyncStatus = (on) => {
    const status = document.querySelector('[data-cart-sync-status]');
    if (!status) return;
    clearTimeout(syncStatusTimer);
    if (on) syncStatusTimer = setTimeout(() => { status.hidden = false; }, 150);
    else status.hidden = true;
  };

  const runCartSync = async () => {
    if (cartSyncing) return;
    cartSyncing = true;
    setSyncStatus(true);
    const sectionId = cartSectionId();
    const render = { sections: sectionId, sections_url: location.pathname };
    try {
      let cart = null;
      for (let line = [...cartLines.values()].find(isDirty); line; line = [...cartLines.values()].find(isDirty)) {
        cart = await syncLine(line, render);
        // A line that merged into another (same size and plan) no longer maps 1:1 to its row: show the real cart.
        if (line.qty && !cart.items.some((item) => item.key === line.key && item.quantity === line.qty)) break;
      }
      cartLines.clear();
      if (cart) applyCartSection(cart, sectionId);
    } catch (err) {
      console.error(err);
      alert('変更できませんでした。再度お試しください。\n' + (err.message || ''));
      location.reload();
      return;
    } finally {
      cartSyncing = false;
      setSyncStatus(false);
    }
    if (checkoutAfterSync) {
      const btn = checkoutAfterSync;
      checkoutAfterSync = null;
      btn.form.requestSubmit(btn);
    }
  };

  const markActive = (chip, active) => {
    chip.classList.toggle('is-active', active);
    chip.setAttribute('aria-checked', String(active));
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-line-change], [data-line-remove]');
    const row = btn && btn.closest('[data-line-item]');
    if (!row) return;
    e.preventDefault();
    const line = lineFor(row);
    line.want.qty = 'lineRemove' in btn.dataset ? 0 : Math.max(0, line.want.qty + Number(btn.dataset.lineChange));
    if (line.want.qty === 0) {
      row.remove();
      showSubtotal();
    } else {
      const input = row.querySelector('input[name="updates[]"]');
      if (input) input.value = line.want.qty;
      showWanted(line);
    }
    runCartSync();
  });

  document.addEventListener('click', (e) => {
    const chip = e.target.closest('[data-cart-variant], [data-cart-plan]');
    const row = chip && chip.closest('[data-line-item]');
    if (!row || chip.classList.contains('is-active')) return;
    e.preventDefault();
    const line = lineFor(row);
    if (chip.dataset.cartVariant) {
      chip.parentElement.querySelectorAll('[data-cart-variant]').forEach((el) => markActive(el, el === chip));
      line.want.variant = chip.dataset.cartVariant;
      const { plans } = pricesFor(line, line.want.variant);
      if (line.want.plan && !(line.want.plan in plans)) line.want.plan = Object.keys(plans)[0] || '';
    } else if (chip.dataset.cartPlan) {
      const { plans } = pricesFor(line, line.want.variant);
      line.want.plan = line.plan in plans && line.plan ? line.plan : Object.keys(plans)[0] || '';
    } else {
      line.want.plan = '';
    }
    row.querySelectorAll('[data-cart-plan]').forEach((el) => markActive(el, !el.dataset.cartPlan === !line.want.plan));
    showWanted(line);
    runCartSync();
  });

  // The checkout button posts updates[] for the rows on screen; wait until they match the cart.
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('button[name="checkout"]');
    if (!btn || !cartSyncing) return;
    e.preventDefault();
    btn.textContent = '更新中…';
    checkoutAfterSync = btn;
  });

  // ---------- Quantity widget ----------
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    const wrap = btn.closest('[data-qty]');
    if (!wrap) return;
    const input = wrap.querySelector('input[type="number"]');
    if (!input) return;
    const step = parseInt(btn.dataset.qtyStep, 10);
    const min = parseInt(input.min || '1', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ---------- Purchase state sync (cart-purchase ↔ purchase-bar) ----------
  const PURCHASE_EVT = 'totocola:purchase-sync';
  const dispatchPurchase = (detail) => {
    document.dispatchEvent(new CustomEvent(PURCHASE_EVT, { detail }));
  };

  // ---------- Purchase selector (size + mode buttons) ----------
  const initPurchaseSelector = (root) => {
    const sizeBtns = root.querySelectorAll('[data-size-id]');
    const modeBtns = root.querySelectorAll('[data-mode]');
    const subscriptionBtn = root.querySelector('[data-mode-subscription]');
    const form = root.querySelector('[data-purchase-form]');
    const variantInput = root.querySelector('[data-input-variant]');
    const planInput = root.querySelector('[data-input-plan]');
    const displayDesc = root.querySelector('[data-display-desc]');
    const featureBlocks = root.querySelectorAll('[data-features-for]');
    const qtySelect = root.querySelector('select[name="quantity"]');

    let activeSize = null;
    let activeMode = 'onetime';
    let isSyncing = false;

    const broadcast = () => {
      if (isSyncing) return;
      dispatchPurchase({
        source: 'cart-purchase',
        variantId: variantInput ? variantInput.value : (activeSize ? activeSize.dataset.variantId : ''),
        mode: activeMode,
        quantity: qtySelect ? (parseInt(qtySelect.value, 10) || 1) : 1
      });
    };

    const setText = (el, text) => { if (el) el.textContent = text || ''; };
    const setHidden = (el, hidden) => { if (el) el.hidden = hidden; };

    const refreshSizePrices = () => {
      sizeBtns.forEach((btn) => {
        const d = btn.dataset;
        const priceEl = btn.querySelector('[data-size-price]');
        const compareEl = btn.querySelector('[data-size-compare]');
        if (!priceEl) return;
        if (activeMode === 'subscription' && d.subscriptionFirst) {
          if (compareEl) {
            compareEl.textContent = d.onetimePrice || '';
            compareEl.hidden = false;
          }
          priceEl.textContent = d.subscriptionFirst;
        } else {
          if (compareEl) compareEl.hidden = true;
          priceEl.textContent = d.onetimePrice || '';
        }
      });
    };

    const refreshMode = () => {
      const giftEntry = root.querySelector('[data-gift-entry]');
      if (giftEntry) {
        giftEntry.hidden = activeMode !== 'onetime';
        if (giftEntry.hidden) giftEntry.open = false;
      }
      modeBtns.forEach((b) => {
        const on = b.dataset.mode === activeMode;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      refreshSizePrices();

      if (!activeSize) return;
      const d = activeSize.dataset;

      if (planInput) {
        if (activeMode === 'subscription' && d.sellingPlanId) {
          planInput.value = d.sellingPlanId;
          planInput.disabled = false;
        } else {
          planInput.value = '';
          planInput.disabled = true;
        }
      }
    };

    const selectSize = (btn) => {
      sizeBtns.forEach((b) => {
        const on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      activeSize = btn;
      const d = btn.dataset;

      setText(displayDesc, d.description);

      featureBlocks.forEach((f) => {
        f.hidden = f.dataset.featuresFor !== d.sizeId;
      });

      if (variantInput) variantInput.value = d.variantId || '';

      const isAvailable = d.available === 'true';
      setHidden(form, !isAvailable);

      const hasSubscription = !!d.sellingPlanId && d.sellingPlanId !== '';
      if (subscriptionBtn) {
        subscriptionBtn.hidden = !hasSubscription;
        subscriptionBtn.disabled = !hasSubscription;
      }
      if (!hasSubscription && activeMode === 'subscription') {
        activeMode = 'onetime';
      }

      refreshMode();
    };

    sizeBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.getAttribute('aria-disabled') === 'true') return;
        selectSize(btn);
        broadcast();
      });
    });

    modeBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.disabled || btn.hidden) return;
        activeMode = btn.dataset.mode;
        refreshMode();
        broadcast();
      });
    });

    if (qtySelect) {
      qtySelect.addEventListener('change', broadcast);
    }

    document.addEventListener(PURCHASE_EVT, (e) => {
      if (!e.detail || e.detail.source === 'cart-purchase') return;
      isSyncing = true;
      if (e.detail.variantId) {
        const target = Array.from(sizeBtns).find((b) => b.dataset.variantId === e.detail.variantId);
        if (target && target !== activeSize && target.getAttribute('aria-disabled') !== 'true') {
          selectSize(target);
        }
      }
      if (e.detail.mode && e.detail.mode !== activeMode) {
        if (e.detail.mode !== 'subscription' || !subscriptionBtn || (!subscriptionBtn.hidden && !subscriptionBtn.disabled)) {
          activeMode = e.detail.mode;
          refreshMode();
        }
      }
      if (qtySelect && e.detail.quantity != null && qtySelect.value !== String(e.detail.quantity)) {
        qtySelect.value = e.detail.quantity;
      }
      isSyncing = false;
    });

    const initial =
      Array.from(sizeBtns).find((b) => b.classList.contains('is-active') && b.dataset.available === 'true') ||
      Array.from(sizeBtns).find((b) => b.dataset.available === 'true') ||
      sizeBtns[0];
    if (initial) selectSize(initial);

    // After all modules init, push the initial state to the bar
    setTimeout(broadcast, 0);
  };

  document.querySelectorAll('[data-purchase]').forEach(initPurchaseSelector);

  // ---------- Purchase media gallery (main + thumbnails) ----------
  document.querySelectorAll('[data-purchase-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-thumb]'));
    if (!main || thumbs.length === 0) return;

    const selectThumb = (thumb, scroll = false) => {
      const src = thumb.dataset.thumbSrc;
      if (!src) return;
      main.src = src;
      main.removeAttribute('srcset');
      thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
      if (scroll && typeof thumb.scrollIntoView === 'function') {
        thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => selectThumb(thumb));
    });

    const move = (dir) => {
      const currentIdx = thumbs.findIndex((t) => t.classList.contains('is-active'));
      const startIdx = currentIdx === -1 ? 0 : currentIdx;
      let nextIdx = startIdx + dir;
      if (nextIdx < 0) nextIdx = thumbs.length - 1;
      if (nextIdx >= thumbs.length) nextIdx = 0;
      selectThumb(thumbs[nextIdx], true);
    };

    gallery.querySelectorAll('[data-thumb-prev]').forEach((btn) => {
      btn.addEventListener('click', () => move(-1));
    });
    gallery.querySelectorAll('[data-thumb-next]').forEach((btn) => {
      btn.addEventListener('click', () => move(1));
    });
  });

  // ---------- Sticky purchase bar (bottom) ----------
  const purchaseBars = document.querySelectorAll('[data-purchase-bar]');
  if (purchaseBars.length) {
    document.body.classList.add('has-purchase-bar');
    purchaseBars.forEach((bar) => {
      const sizeSelect = bar.querySelector('[data-bar-size]');
      const variantInput = bar.querySelector('[data-bar-input-variant]');
      const planInput = bar.querySelector('[data-bar-input-plan]');
      const priceDisplay = bar.querySelector('[data-bar-price]');
      const compareDisplay = bar.querySelector('[data-bar-compare]');
      const modeSelect = bar.querySelector('[data-bar-mode-select]');
      const qtySelect = bar.querySelector('select[name="quantity"]');
      let activeMode = modeSelect ? modeSelect.value : 'onetime';
      let isSyncing = false;

      const refresh = () => {
        const opt = sizeSelect && sizeSelect.selectedOptions[0];
        if (variantInput && opt) variantInput.value = opt.value;
        const onetime = opt ? opt.dataset.price : '';
        const subPrice = opt ? opt.dataset.subPrice : '';
        const planId = opt ? opt.dataset.sellingPlan : '';

        if (activeMode === 'subscription' && subPrice) {
          if (compareDisplay) {
            compareDisplay.textContent = onetime || '';
            compareDisplay.hidden = false;
          }
          if (priceDisplay) priceDisplay.textContent = subPrice;
          if (planInput) {
            planInput.value = planId || '';
            planInput.disabled = !planId;
          }
        } else {
          if (compareDisplay) compareDisplay.hidden = true;
          if (priceDisplay) priceDisplay.textContent = onetime || '';
          if (planInput) {
            planInput.value = '';
            planInput.disabled = true;
          }
        }
      };

      const broadcast = () => {
        if (isSyncing) return;
        dispatchPurchase({
          source: 'purchase-bar',
          variantId: sizeSelect ? sizeSelect.value : (variantInput ? variantInput.value : ''),
          mode: activeMode,
          quantity: qtySelect ? (parseInt(qtySelect.value, 10) || 1) : 1
        });
      };

      if (sizeSelect) sizeSelect.addEventListener('change', () => { refresh(); broadcast(); });

      if (modeSelect) {
        modeSelect.addEventListener('change', () => {
          activeMode = modeSelect.value;
          refresh();
          broadcast();
        });
      }

      if (qtySelect) qtySelect.addEventListener('change', broadcast);

      document.addEventListener(PURCHASE_EVT, (e) => {
        if (!e.detail || e.detail.source === 'purchase-bar') return;
        isSyncing = true;
        if (sizeSelect && e.detail.variantId && sizeSelect.value !== e.detail.variantId) {
          const opt = Array.from(sizeSelect.options).find((o) => o.value === e.detail.variantId && !o.disabled);
          if (opt) {
            sizeSelect.value = e.detail.variantId;
            refresh();
          }
        }
        if (modeSelect && e.detail.mode && modeSelect.value !== e.detail.mode) {
          modeSelect.value = e.detail.mode;
          activeMode = e.detail.mode;
          refresh();
        }
        if (qtySelect && e.detail.quantity != null && qtySelect.value !== String(e.detail.quantity)) {
          qtySelect.value = e.detail.quantity;
        }
        isSyncing = false;
      });

      refresh();
    });
  }

  // ---------- Article: TOC, reading time, progress, share, auto product link ----------
  const article = document.querySelector('[data-article-body]');
  if (article) {
    const content = article.querySelector('[data-article-content]');

    // Reading time (CJK-aware: 600 chars/min for JP)
    const readtimeEl = article.querySelector('[data-readtime]');
    if (readtimeEl && content) {
      const text = content.textContent || '';
      const chars = text.replace(/\s+/g, '').length;
      const minutes = Math.max(1, Math.round(chars / 600));
      readtimeEl.textContent = '約' + minutes + '分';
    }

    // TOC auto from h2
    const tocEl = article.querySelector('[data-toc]');
    const tocList = article.querySelector('[data-toc-list]');
    if (tocEl && tocList && content) {
      const h2s = content.querySelectorAll('h2');
      if (h2s.length >= 2) {
        h2s.forEach((h, i) => {
          if (!h.id) h.id = 'h-' + (i + 1) + '-' + (h.textContent || '').replace(/\s+/g, '-').slice(0, 24);
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = '#' + h.id;
          a.textContent = h.textContent || '';
          li.appendChild(a);
          tocList.appendChild(li);
        });
        tocEl.hidden = false;
        // Smooth scroll
        tocList.addEventListener('click', (e) => {
          const a = e.target.closest('a[href^="#"]');
          if (!a) return;
          const id = a.getAttribute('href').slice(1);
          const target = document.getElementById(id);
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            history.replaceState(null, '', '#' + id);
          }
        });
      }
    }

    // Read progress bar
    const progressEl = article.querySelector('[data-read-progress-bar]');
    if (progressEl && content) {
      let pTicking = false;
      const updateProgress = () => {
        const rect = content.getBoundingClientRect();
        const total = rect.height - window.innerHeight;
        const passed = Math.min(Math.max(-rect.top, 0), Math.max(total, 1));
        const ratio = total > 0 ? passed / total : 0;
        progressEl.style.transform = 'scaleX(' + ratio.toFixed(3) + ')';
        pTicking = false;
      };
      window.addEventListener('scroll', () => {
        if (!pTicking) {
          requestAnimationFrame(updateProgress);
          pTicking = true;
        }
      }, { passive: true });
      updateProgress();
    }

    // Share copy URL
    const copyBtn = article.querySelector('[data-share-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', async () => {
        const url = copyBtn.dataset.shareUrl || window.location.href;
        try {
          await navigator.clipboard.writeText(url);
          copyBtn.classList.add('is-copied');
          setTimeout(() => copyBtn.classList.remove('is-copied'), 1600);
        } catch (e) {
          console.error(e);
        }
      });
    }

    // Auto-link product names (every occurrence) → / (TOP)
    if (content) {
      const targets = ['ととコーラ', 'クラフトコーラ'];
      const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT, {
        acceptNode: (node) => {
          if (!node.nodeValue || node.parentElement.closest('a, h1, h2, h3, h4, code, pre')) return NodeFilter.FILTER_REJECT;
          for (const t of targets) if (node.nodeValue.includes(t)) return NodeFilter.FILTER_ACCEPT;
          return NodeFilter.FILTER_REJECT;
        }
      });
      const nodes = [];
      let n;
      while ((n = walker.nextNode())) nodes.push(n);
      const re = new RegExp('(' + targets.map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|') + ')', 'g');
      nodes.forEach((node) => {
        const html = node.nodeValue.replace(re, '<a href="/" class="article__inline-link">$1</a>');
        if (html !== node.nodeValue) {
          const span = document.createElement('span');
          span.innerHTML = html;
          node.replaceWith(...span.childNodes);
        }
      });
    }
  }

})();
